/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface TopicItemRequest {

    title?: string;

    type?: string;

    production_id?: string;

    vod_id?: string;

    article_id?: string;

    brand_id?: string;

    brand_name?: string;

    brand_logo?: string;

    thumbnail?: string;

    duration?: string;

    vod_type?: string;

    /**
     * True if this item is premium
     */
    premium?: boolean;

    /**
     * True if this premium item is currently unlocked
     */
    premium_unlocked?: boolean;

    date?: string;

}

@Model('TopicItem')
export class ApiTopicItem extends BaseModel implements TopicItemRequest {

    
    
    title: string;

    
    
    type: string;

    
    
    production_id: string;

    
    
    vod_id: string;

    
    
    article_id: string;

    
    
    brand_id: string;

    
    
    brand_name: string;

    
    
    brand_logo: string;

    
    
    thumbnail: string;

    
    
    duration: string;

    
    
    vod_type: string;

    /**
     * True if this item is premium
     */
    
    
    premium: boolean;

    /**
     * True if this premium item is currently unlocked
     */
    
    
    premium_unlocked: boolean;

    
    
    date: string;

}
